import { Stack, Tab, TabPanel, Tabs } from '@all-manager/design-system-v2';
import FullPageLayout from '../../../../layout/FullPageLayout/FullPageLayout';
import OverviewTab from '../../components/OverviewTab/OverviewTab';
import PendingSubTopicList from '../../components/PendingSubTopicList/PendingSubTopicList';
import { usePendingSubTopicPage } from './usePendingSubTopicPage';

export default function PendingSubTopicPage() {
  const { activeTab, handleTabChange } = usePendingSubTopicPage();

  return (
    <FullPageLayout
      htmlTitle="Sujets en cours"
      title="Sujets en cours"
    >
      <Stack spacing={2}>
        <Tabs
          divider
          value={activeTab}
          onChange={handleTabChange}
          aria-label="Vues de la page d'accueil"
        >
          <Tab label="Vue synthèse" id="home-tab-0" aria-controls="home-tabpanel-0" value={0} />
          <Tab label="Sujets en cours" id="home-tab-1" aria-controls="home-tabpanel-1" value={1} />
        </Tabs>

        <TabPanel value={0} activeValue={activeTab} id="home-tabpanel-0" aria-labelledby="home-tab-0">
          <OverviewTab />
        </TabPanel>

        <TabPanel value={1} activeValue={activeTab} id="home-tabpanel-1" aria-labelledby="home-tab-1">
          <PendingSubTopicList />
        </TabPanel>
      </Stack>
    </FullPageLayout>
  );
}
